<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl" persistent)
    v-form(ref="form")
      v-card
        v-card-title.pa-4
          v-spacer 
          .text-xl.font-bold.ml-10 Create new contact
          v-spacer
          v-btn(icon @click="showDialog = false" color="primary" small)
            v-icon mdi-close
        v-divider

        v-card-text.pa-8.primary--text
          .text-md.font-medium.mb-4 Fill in contact information below
          yc-text-field.mb-3(label="Name" v-model="form.name" :rules="rules.not_empty")
          yc-phone-input.mb-3(placeholder="Phone number" v-model="form.phone" :rules="rules.not_empty")
          yc-text-field.mb-3(label="Email (optional)" v-model="form.email" :rules="form.email ? rules.valid_email : []" type="email")
          yc-text-field.mb-3(label="Total Contribution" v-model="form.lifetime_value" placeholder="100" :prefix="$currency.symbol" type="number" :rules="rules.not_empty")
        v-divider

        v-card-actions.px-6.py-3
          v-btn.button-md.underline.ml-n4(@click="showDialog = false" color="primary" text) {{ $t('cancel') }}
          v-spacer
          v-btn.button-md.white--text(@click="create" color="primary" depressed :loading="isLoading") {{ $t('create') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CreateDonorDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    form: {},
    maritalStatuses: [
      { id: 'single', label: 'Single' },
      { id: 'married', label: 'Married' },
    ],
    genders: [
      { id: 'male', label: 'Male' },
      { id: 'female', label: 'Female' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    create () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        name: this.form.name,
        phone: this.form.phone,
        email: this.form.email,
        lifetime_value: this.form.lifetime_value * this.$currency.multiplier
      }
      this.$axios.post(`/donations/${this.company.slug}/donors`, data)
        .then(() => {
          this.showMessage(['success', 'Customer successfully created'])
          this.showDialog = false
          this.$emit('success')
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data[0]) {
            message = err.response.data[0]
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>